var map = {
	"./en/activity.json": [
		81159,
		159
	],
	"./en/auth.json": [
		72816,
		816
	],
	"./en/convert.json": [
		85645,
		645
	],
	"./en/core.json": [
		60121,
		121
	],
	"./en/interest.json": [
		88488,
		488
	],
	"./en/kyc.json": [
		9911,
		911
	],
	"./en/margin.json": [
		49644,
		644
	],
	"./en/order.json": [
		84566,
		566
	],
	"./en/send.json": [
		84627,
		8
	],
	"./en/stream.json": [
		16142,
		142
	],
	"./en/transfer.json": [
		83477,
		477
	],
	"./en/translation.json": [
		29737,
		737
	],
	"./en/user.json": [
		47705,
		705
	],
	"./es/activity.json": [
		48450,
		450
	],
	"./es/auth.json": [
		25053,
		53
	],
	"./es/convert.json": [
		33774,
		774
	],
	"./es/core.json": [
		9452,
		452
	],
	"./es/interest.json": [
		4829,
		829
	],
	"./es/kyc.json": [
		18100,
		100
	],
	"./es/margin.json": [
		6853,
		853
	],
	"./es/order.json": [
		89429,
		429
	],
	"./es/send.json": [
		74549,
		549
	],
	"./es/stream.json": [
		80431,
		431
	],
	"./es/transfer.json": [
		93260,
		260
	],
	"./es/translation.json": [
		51738,
		738
	],
	"./es/user.json": [
		73524,
		524
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46088;
module.exports = webpackAsyncContext;